import { getUserInfo, isAndroid, goAppPath, getAppPath, removeUserInfo, goDownloadPage } from '$common/utils/common/common'

export default {
  methods: {
    goPassPage() {
      let route = 'SuperApp://GoNow/BookOrder'
      if (this.isWownowApp) {
        window?.WOWNOW?.navigationToRoute({ route });
      } else {
        const clearCallAppTimer = () => {
          window.goAppPathTimer && clearTimeout(window.goAppPathTimer)
          document.removeEventListener('visibilitychange', clearCallAppTimer)
        }
        document.addEventListener('visibilitychange', clearCallAppTimer, false)
        window.goAppPathTimer = window.setTimeout(() => {
          clearCallAppTimer()
          goDownloadPage()
        }, 2500)
        goAppPath({ routepath: route, url: route })

      }
    },
  }
}
